<template>
  <div class="dashboard-shell">
    <PageLoader :storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#427D2D" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-container fluid class="px-4 py-0">
      <v-layout wrap justify-center pt-2>
        <v-flex xs12>
          <v-layout wrap justify-start>
            <v-flex
              v-for="(card, index) in cards"
              :key="index"
              xs12
              sm6
              md4
              lg3
              pa-3
            >
              <StatCard
                :card="card"
                @action="redirectToPage(card.action, card.title)"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-start class="d-flex align-stretch">
        <v-flex xs12 lg7 pa-3 class="d-flex">
          <v-card elevation="0" class="chart-card card-cases d-flex flex-column justify-space-between fill-height pa-5" style="width: 100%;">
            <div style="width: 100%;">
              <v-layout wrap justify-start>
                <v-flex xs12 lg9>
                  <div class="d-flex align-center">
                    <v-icon color="#10b981" class="mr-2 mb-1" size="26">mdi-chart-timeline-variant</v-icon>
                    <span class="reportone">Total Cases Overview</span>
                  </div>
                </v-flex>
                <v-flex xs12 lg3>
                  <v-select
                    outlined
                    dense
                    rounded
                    color="#10b981"
                    :hide-details="true"
                    :items="yearitems"
                    v-model="lineyeardata"
                  ></v-select>
                </v-flex>
              </v-layout>
            </div>
            <div style="width: 100%;" class="pt-4 flex-grow-1 d-flex align-center">
              <div style="width: 100%;" v-if="flag1">
                <highcharts :options="histogramOptions" style="width: 100%;"></highcharts>
              </div>
            </div>
          </v-card>
        </v-flex>
        <v-flex xs12 lg5 pa-3 class="d-flex">
          <v-card elevation="0" class="chart-card card-species d-flex flex-column justify-space-between fill-height pa-5" style="width: 100%;">
            <div style="width: 100%;">
              <div class="d-flex align-center">
                <v-icon color="#eab308" class="mr-2 mb-1" size="26">mdi-chart-donut</v-icon>
                <span class="reportone">Top Common Snake Species</span>
              </div>
            </div>
            <div style="width: 100%;" class="pt-6 flex-grow-1 d-flex align-center">
              <div style="width: 100%;" v-if="flag">
                <highcharts
                  :options="highchartsOptions"
                  :constructor-type="'chart'"
                  style="width: 100%;"
                ></highcharts>
              </div>
            </div>
            <div style="width: 100%;" class="pt-6 text-center" v-if="flag">
              <span
                @click="redirectToSnakeDetails()"
                class="viewdetails-btn"
                >View All Species <v-icon small color="white" class="ml-1">mdi-arrow-right</v-icon></span
              >
            </div>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-start pt-4>
        <v-flex xs12 pa-3>
          <v-card elevation="0" class="chart-card card-leaderboard">
            <v-layout wrap justify-start pa-5>
              <v-flex xs12>
                <v-layout wrap justify-start>
                  <v-flex xs12 pa-3>
                    <span class="reportone"
                      >Top Rescuers of the Year {{ currentYear }}</span
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 pt-4 pb-2>
                <v-layout wrap justify-start>
                  <v-flex
                    xs12
                    sm6
                    md4
                    lg3
                    v-for="(item, index) in topusers"
                    :key="item.name"
                    pa-2
                  >
                    <div :class="['leaderboard-card', `rank-${index + 1}`]">
                      <div class="rank-badge">
                        <span v-if="index < 3"><v-icon small color="white">mdi-trophy</v-icon></span>
                        <span v-else>#{{ index + 1 }}</span>
                      </div>
                      <div class="leaderboard-info" v-if="item && item.user && item.user.name">
                        <div class="rescuername">{{ item.user.name }}</div>
                        <div class="rescuervalue d-flex align-center mt-1">
                          <v-icon x-small color="#10b981" class="mr-1">mdi-snake</v-icon>
                          <span v-if="item.count">{{ item.count }} Rescues</span>
                          <span v-else>0 Rescues</span>
                        </div>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 v-if="topusers && topusers.length > 0">
                <v-layout wrap justify-end>
                  <v-flex xs12 pa-3 class="text-end">
                    <span
                      class="viewdetails-btn"
                      @click="redirectToUsersDetails()"
                      style="cursor: pointer"
                      >View More <v-icon small color="white" class="ml-1">mdi-arrow-right</v-icon></span
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex
                xs12
                align-self-start
                pl-4
                v-if="topusers && topusers.length === 0"
              >
                <span class="reporttwo">No data available!</span>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import StatCard from "@/components/Common/statCard";
export default {
  components: {
    StatCard,
  },
  data() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.toLocaleString("default", {
      month: "long",
    });
    return {
      currentYear,
      currentMonth,
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      pages: 0,
      count: 20,
      cards: [
        {
          title: "Total Users",
          value: 0,
          action: "View Map",
          icon: require("@/assets/images/totalusers.png"),
          mdiIcon: "mdi-account-group-outline",
          color: "green",
        },
        {
          title: "Snake Rescuers",
          value: 0,
          action: "View Map",
          icon: require("@/assets/images/icon_snake.png"),
          mdiIcon: "mdi-account-hard-hat",
          color: "blue",
        },
        {
          title: "Snakes Rescued",
          value: 0,
          action: "View Map",
          icon: require("@/assets/images/snakeresc.png"),
          mdiIcon: "mdi-hand-heart-outline",
          color: "red",
        },
        {
          title: "Identification Help",
          value: 0,
          action: "View Details",
          icon: require("@/assets/images/idhelp.png"),
          mdiIcon: "mdi-help-circle-outline",
          color: "yellow",
        },
        {
          title: "Listed Hospitals",
          value: 0,
          action: "View Map",
          icon: require("@/assets/images/listhosp.png"),
          mdiIcon: "mdi-hospital-building",
          color: "red",
        },
        {
          title: "Snake Bite Cases",
          value: 0,
          action: "View Details",
          icon: require("@/assets/images/snakedeath.png"),
          mdiIcon: "mdi-heart-pulse",
          color: "yellow",
        },
        {
          title: "Listed Snakes",
          value: 0,
          action: "View Details",
          icon: require("@/assets/images/listedsnakes.png"),
          mdiIcon: "mdi-snake",
          color: "light-green",
        },
        {
          title: "Public users",
          value: 0,
          action: "View Details",
          icon: require("@/assets/images/publicusers.png"),
          mdiIcon: "mdi-account-network-outline",
          color: "purple",
        },
      ],
      dates: [],
      details: [
        { title: "Most Common Snakes - 2024", icon: "mdi-snake" },
        { title: "Top Rescuers of July", icon: "mdi-snake" },
        { title: "Top Rescuers of 2024", icon: "mdi-snake" },
      ],
      topsnakes: [],
      topusers: [],
      chartOptions3: {
        chart: {
          height: 262,
          type: "bar",
        },
        plotOptions: {
          bar: {
            columnWidth: "45%",
            distributed: true,
          },
        },
        dataLabels: {
          enabled: true,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: "12px",
            },
          },
          title: {
            text: "Year",
          },
        },
        yaxis: {
          title: {
            text: "Count",
          },
        },
      },
      series3: [
        {
          name: "Count",
          data: [],
        },
      ],
      yearitems: ["Last 7 Years", "Last 5 Years"],
      lineyeardata: "Last 5 Years",
      options: {
        chart: {
          type: "donut",
        },
        labels: [], // For the animal names
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
      series: [],
      flag: false,
      flag1: false,
      yearwiseData: [],
      histogramOptions: {
        chart: {
          type: "column",
          height: 400,
          backgroundColor: "transparent",
        },
        title: {
          text: "",
        },
        xAxis: {
          categories: [],
          title: {
            text: "Year",
            style: {
              color: "#64748b",
              fontFamily: "poppinsregular, sans-serif",
            },
          },
          labels: {
            style: {
              color: "#64748b",
              fontFamily: "poppinsregular, sans-serif",
            },
          },
          lineColor: "rgba(15, 23, 42, 0.08)",
          tickColor: "rgba(15, 23, 42, 0.08)",
        },
        credits: {
          enabled: false
        },
        yAxis: {
          min: 0,
          title: {
            text: "Total Cases",
            style: {
              color: "#64748b",
              fontFamily: "poppinsregular, sans-serif",
            },
          },
          labels: {
            style: {
              color: "#64748b",
              fontFamily: "poppinsregular, sans-serif",
            },
          },
          gridLineColor: "rgba(15, 23, 42, 0.05)",
        },
        legend: {
          itemStyle: {
            color: "#0f172a",
            fontFamily: "poppinsregular, sans-serif",
          },
          itemHoverStyle: {
            color: "#10b981",
          },
        },
        plotOptions: {
          column: {
            pointWidth: 30,
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              style: {
                color: "#0f172a",
                textOutline: "none",
                fontFamily: "poppinsmedium, sans-serif",
              },
            },
          },
        },
        series: [
          {
            name: "Reports",
            data: [],
            color: "#00E096",
          },
        ],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 600
            },
            chartOptions: {
              chart: {
                height: 300
              },
              xAxis: {
                labels: {
                  style: {
                    fontSize: "10px"
                  }
                }
              },
              yAxis: {
                labels: {
                  style: {
                    fontSize: "10px"
                  }
                }
              },
              plotOptions: {
                column: {
                  pointWidth: 15,
                  dataLabels: {
                    style: {
                      fontSize: "9px"
                    }
                  }
                }
              }
            }
          }]
        }
      },
      highchartsOptions: {
        chart: {
          type: "pie",
          height: 344,
          backgroundColor: "transparent",
        },
        colors: [
          "#10b981", // Emerald
          "#3b82f6", // Royal Blue
          "#facc15", // Yellow
          "#ec4899", // Pink
          "#8b5cf6", // Purple
          "#06b6d4", // Cyan
          "#f97316", // Orange
          "#ef4444", // Red
          "#14b8a6", // Teal
          "#6366f1"  // Indigo
        ],
        credits: {
          enabled: false
        },
        title: {
          text: null,
          enabled: true,
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
          backgroundColor: "rgba(15, 23, 42, 0.95)",
          borderWidth: 1,
          borderColor: "rgba(255, 255, 255, 0.1)",
          style: {
            color: "#ffffff",
            fontFamily: "poppinsregular, sans-serif",
          },
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            borderRadius: 6,
            borderWidth: 2,
            borderColor: "rgba(15, 23, 42, 0.08)",
            innerSize: "60%",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b>: {point.percentage:.1f} %",
              style: {
                color: "#0f172a",
                textOutline: "none",
                fontFamily: "poppinsmedium, sans-serif",
                fontSize: "11px",
              },
            },
          },
        },
        series: [
          {
            name: "Reports",
            colorByPoint: true,
            data: [],
          },
        ],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 600
            },
            chartOptions: {
              chart: {
                height: 300
              },
              plotOptions: {
                pie: {
                  dataLabels: {
                    style: {
                      fontSize: "9px"
                    }
                  }
                }
              }
            }
          }]
        }
      },
      seriesData: [],
    };
  },
  beforeMount() {
    this.countData();
    this.yearData();
    this.topsnakesData();
  },
  watch: {
    lineyeardata() {
      this.yearData();
    },
  },
  methods: {
    redirectToSnakeDetails() {
      this.$router.push({ path: "/officetopcommonsnakes" });
    },
    topsnakesData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/topsnakes/all",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            const animalReportSummary = response.data.data.allSnakes.slice(0, 10);
            this.series = animalReportSummary.map((item) => item.totalReports);
            this.options.labels = animalReportSummary.map((item) => item.name);
            const seriesData = animalReportSummary.map((item) => ({
              name: item.snakeName,
              y: item.count,
            }));
            this.highchartsOptions.series[0].data = seriesData;
            this.flag = true;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
    },
    redirectToPage(action, title) {
      if (title === "Total Users") {
        this.$router.push({ path: "/officeusermap" });
      } else if (title === "Snake Rescuers") {
        this.$router.push({ path: "/officerescuermap" });
      } else if (title === "Snakes Rescued") {
        this.$router.push({ path: "/officesnakerescued" });
      } else if (title === "Identification Help") {
        this.$router.push({ path: "/officeidentificationhelp" });
      } else if (title === "Listed Hospitals") {
        this.$router.push({ path: "/officehospitalMap" });
      } else if (title === "Snake Bite Cases" || title === "Snake Bite cases") {
        this.$router.push({ path: "/officers/snakeBiteOfficers" });
      } else if (title === "Listed Snakes") {
        this.$router.push({ path: "/officelistedSnakes" });
      } else if (title === "Public users" || title === "Public Users") {
        this.$router.push({ path: "/officeusersList" });
      }
    },
    redirectToUsersDetails() {
      this.$router.push({ path: "/officetopUsers" });
    },
    redirectToUsersyearDetails() {
      this.$router.push({ path: "/topUsersyear" });
    },
    countData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/stats",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.cards[0].value = response.data.data.count_total_users;
            this.cards[1].value = response.data.data.count_total_rescuer;
            this.cards[2].value = response.data.data.count_total_locations;
            this.cards[3].value = response.data.data.count_identify;
            this.cards[4].value = response.data.data.count_hospital;
            this.cards[5].value = response.data.data.count_management;
            this.cards[6].value = response.data.data.count_snakes;
            this.cards[7].value = response.data.data.count_users;
            this.topsnakes = response.data.data.topsnakes;
            const topcommonsnakesSummary = response.data.data.topsnakes;
            this.series = topcommonsnakesSummary.map((item) => item.count);
            this.options.labels = topcommonsnakesSummary.map(
              (item) => item.snake.name
            );
            this.flag = true;
            this.topusers = response.data.data.topusers;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    yearData() {
      this.appLoading = true;
      const yearMapping = {
        "Last 7 Years": 7,
        "Last 5 Years": 5,
      };
      const selectedYears = yearMapping[this.lineyeardata] || 5;
      axios({
        method: "GET",
        url: "/user/yearwise",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          year: selectedYears,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.yearwiseData = response.data.data;
            this.histogramOptions.xAxis.categories = this.yearwiseData.map(
              (item) => item.year
            );
            this.histogramOptions.series[0].data = this.yearwiseData.map(
              (item) => item.count
            );
            this.flag1 = true;
            this.dates = response.data.data;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.detailshead {
  font-family: poppinsmedium, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
}
.value {
  font-family: poppinsbold, sans-serif;
  font-size: 32px;
  font-weight: 700;
  line-height: 1;
}
.listvalue {
  font-family: poppinsbold;
  font-size: 14px;
}
.sarpa {
  font-family: poppinsmedium;
  font-size: 20px;
  font-weight: 500;
}
.viewmore {
  font-family: poppinsmedium;
  font-size: 13px;
  text-decoration: underline;
}
.reportone {
  font-family: poppinssemibold, sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.4;
  color: #0f172a;
}
.rescuername {
  font-family: poppinsmedium, sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #334155;
  transition: all 0.3s ease;
}
.rescuervalue {
  font-family: poppinssemibold, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #10b981;
}
.viewdetails {
  font-family: poppinsregular;
  font-size: 11px;
  font-weight: 400;
  line-height: 16px;
  color: #20b659;
  text-decoration: underline;
  cursor: pointer;
}
.reporttwo {
  font-family: poppinsregular;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #797979;
}

/* Premium Top 3 Leaderboard Cards */
.leaderboard-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 18px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid rgba(15, 23, 42, 0.06);
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  height: 100%;
}
.leaderboard-card:hover {
  transform: translateY(-3px);
  background: #ffffff;
  border-color: rgba(16, 185, 129, 0.2);
  box-shadow: 0 10px 20px -5px rgba(16, 185, 129, 0.1);
}
.leaderboard-card:hover .rescuername {
  color: #10b981 !important;
}
.rank-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 12px;
  font-family: poppinsbold, sans-serif;
  font-weight: 700;
  background: #f1f5f9;
  color: #64748b;
}

/* Premium Top 3 Styling */
.rank-1 {
  background: linear-gradient(135deg, rgba(250, 204, 21, 0.15), rgba(250, 204, 21, 0.05)) !important;
  border-color: rgba(250, 204, 21, 0.4) !important;
}
.rank-1 .rescuername {
  color: #854d0e !important;
}
.rank-1 .rank-badge {
  background: linear-gradient(135deg, #facc15, #ca8a04) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 12px rgba(250, 204, 21, 0.4) !important;
}
.rank-1:hover {
  border-color: #facc15 !important;
  box-shadow: 0 12px 25px rgba(250, 204, 21, 0.2) !important;
}

.rank-2 {
  background: linear-gradient(135deg, rgba(148, 163, 184, 0.15), rgba(148, 163, 184, 0.05)) !important;
  border-color: rgba(148, 163, 184, 0.4) !important;
}
.rank-2 .rescuername {
  color: #334155 !important;
}
.rank-2 .rank-badge {
  background: linear-gradient(135deg, #94a3b8, #64748b) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 12px rgba(148, 163, 184, 0.4) !important;
}
.rank-2:hover {
  border-color: #94a3b8 !important;
  box-shadow: 0 12px 25px rgba(148, 163, 184, 0.2) !important;
}

.rank-3 {
  background: linear-gradient(135deg, rgba(217, 119, 6, 0.15), rgba(217, 119, 6, 0.05)) !important;
  border-color: rgba(217, 119, 6, 0.4) !important;
}
.rank-3 .rescuername {
  color: #9a3412 !important;
}
.rank-3 .rank-badge {
  background: linear-gradient(135deg, #f59e0b, #b45309) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 12px rgba(217, 119, 6, 0.4) !important;
}
.rank-3:hover {
  border-color: #f59e0b !important;
  box-shadow: 0 12px 25px rgba(217, 119, 6, 0.2) !important;
}

/* ---------- page shell ---------- */
.dashboard-shell {
  background: #f6f8fb;
  min-height: 100vh;
  padding-bottom: 2rem;
}

/* Chart and general container Cards */
.chart-card {
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
  border-radius: 16px !important;
  box-shadow: 0 10px 40px -10px rgba(0, 0, 0, 0.06) !important;
  transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1) !important;
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(12px);
}

.chart-card.card-cases {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%) !important;
  border: 1px solid rgba(15, 23, 42, 0.08) !important;
}
.chart-card.card-cases:hover {
  box-shadow: 0 25px 35px -5px rgba(15, 23, 42, 0.12), 0 15px 15px -5px rgba(15, 23, 42, 0.06) !important;
  border-color: rgba(16, 185, 129, 0.3) !important;
}

.chart-card.card-species {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%) !important;
  border: 1px solid rgba(15, 23, 42, 0.08) !important;
}
.chart-card.card-species:hover {
  box-shadow: 0 25px 35px -5px rgba(15, 23, 42, 0.12), 0 15px 15px -5px rgba(15, 23, 42, 0.06) !important;
  border-color: rgba(234, 179, 8, 0.3) !important;
}

.chart-card.card-leaderboard {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%) !important;
  border: 1px solid rgba(15, 23, 42, 0.08) !important;
}
.chart-card.card-leaderboard:hover {
  box-shadow: 0 25px 35px -5px rgba(15, 23, 42, 0.12), 0 15px 15px -5px rgba(15, 23, 42, 0.06) !important;
  border-color: rgba(59, 130, 246, 0.3) !important;
}

/* Sliding Shine on Chart Cards */
.chart-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 150%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(16, 185, 129, 0.04) 25%,
    rgba(16, 185, 129, 0.08) 50%,
    rgba(16, 185, 129, 0.04) 75%,
    rgba(255, 255, 255, 0) 100%
  );
  transform: translateX(-110%) skewX(-20deg);
  transition: none;
  z-index: 1;
  pointer-events: none;
}

.chart-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 25px 35px -5px rgba(16, 185, 129, 0.08), 0 15px 15px -5px rgba(16, 185, 129, 0.04) !important;
  border-color: rgba(16, 185, 129, 0.3) !important;
}

.chart-card:hover::before {
  transform: translateX(110%) skewX(-20deg);
  transition: transform 1.8s cubic-bezier(0.16, 1, 0.3, 1);
}

/* View Details link on charts */
.viewdetails-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: linear-gradient(135deg, #10b981, #059669) !important;
  color: #ffffff !important;
  padding: 8px 20px !important;
  border-radius: 20px !important;
  font-size: 12px !important;
  font-family: poppinsmedium, sans-serif !important;
  cursor: pointer !important;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1) !important;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2) !important;
}
.viewdetails-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(16, 185, 129, 0.35) !important;
}

::v-deep .v-card {
  overflow: hidden;
}
</style>